export default "__VITE_ASSET__3a3k1QzC__"